(function () {
  const root = document.querySelector("[data-inkd-col-subnav]");
  if (!root) return;

  function handleize(str) {
    return String(str || "")
      .trim()
      .toLowerCase()
      .replace(/['"]/g, "")
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "");
  }
  function isArray(x){ return Array.isArray(x); }
  function isObject(x){ return x && typeof x === "object" && !Array.isArray(x); }

  const DATA = {
    "Apparel": {
      "T-Shirts": ["Short Sleeve","Long Sleeve","Performance"],
      "Polos": ["Performance Polos","Cotton Polos", "Golf Apparel"],
      "Hoodies & Fleece": ["Quarter & Half Zips","Full Zips","Pullovers"],
      "Outerwear": ["3-in-1 System Jackets","Insulated & Down Jackets","Lightweight Jackets","Softshell Jackets","Vests"]
    },

    "Personal Care": {
      "Health & Beauty Travel": ["First Aid Kits", "Lip Balms", "Lotions & Sunscreens", "Personal Care 2"],
      "Sanitizers": []
    },

    "Technology": {
      "Cables & Adaptors": [],
      "Chargers & Power Banks": [],
      "Earbuds & Headphones": ["Earbuds/ True Wireless Earbuds","Headphones"],
      "Speakers": [],
      "Tech Accessories": ["Computer Accessories","Phone Accessories","Laptop Sleeves"],
      "Tech Organizers & Stationary": [],
      "Trackers": [],
      "Trends": []
    },

    "Hats": {
      "Headwear": ["Structured","Unstructured","Performance Headwear","Trucker", "Knits"]
    },

    "Home & Office": {
      "Blankets & Towels": ["Home Blankets","Outdoor Blankets","Towels"],
      "Candles": [],
      "Food Storage": [],
      "Kitchen Tools & Housewares": ["Cutting Boards","Kitchen Tools"],
      "Plants": [],
      "Small Appliances": [],
      "Calendars": [],
      "Desk": [],
      "Journals & Notebooks": ["Hard Cover","Soft & Flexible Cover","Smart Notebooks","Planners","Spiral Notebooks"],
      "Lanyards & Badge Holders": [],
      "Office Gift Sets": [],
      "Padfolios": [],
      "Stress Relievers": [],
      "Magnets & Stickers": []
    },

    "Packaging & Add-Ons": {
      "Packaging & Add-Ons": [
      "Full Color Retail Boxes",
      "Mailers",
      "Boxes",
      "Gift Bags",
      "Greeting Cards",
      "Seals",
      "Special Packaging"
    ]},

    "Bags": {
      "Backpacks": [],
      "Tote Bags": ["Convention Totes","Cotton Totes","Non-Woven Totes","Shopper Totes"],
      "Cooler Bags": ["Backpack Coolers","Event Coolers","Lunch Coolers","Hard Coolers","Soft Coolers"],
      "Duffels": [],
      "Briefcases & Messengers": [],
      "Drawstring Bags": [],
      "Fanny Packs & Sling Bags": [],
      "Luggage": []
    },

    "Accessories": {
      "Sunglasses & Eyewear": [],
      "Travel": [],
      "Auto": []
    },

    "Events & Tradeshows": ["Event Displays","Floor Mats","Table Covers"],

    "Drinkware": {
      "Tumblers": [],
      "Vacuum Insulated": ["Bottles", "Vacuum Insulated Mugs", "Vacuum Insulated Tumblers"],
      "Mugs": [],
      "Water Bottles":[],
      "Drinkware Accessories": ["Coasters", "Drinkware Gift Sets"]
    },

    
    "Writing Instruments": {
    "Writing Instruments": ["Gel Pens","Metal Pens","Plastic Pens","Stylus Pens","Pencils","Markers & Highlighters"]
    },



    "Awards": ["Trophies & Plaques","Recognition Gifts"],



      "Food & Gourmet Gifts": {
        "Food & Gourmet Gifts":["All Occasions","Holidays", "Meetings, Events & Celebrations","Thank You & Appreciation","Gourmet Food Gifts","Mints, Candy & Gum"]
      },



    "Outdoor & Sport": {
      "Fitness": [],
      "Towels 2": [],
      "Umbrellas": ["Compact", "Golf Umbrella"],
      "Flashlights & Lanterns": [],
      "Golf": ["Golf Accessories","Golf Balls"],
      "Outdoor Living": ["BBQ & Picnic Sets","Chairs","Outdoor Games", "Camping, Hiking & Gardening"]
    },

    "Plush & Novelties": ["Plush Toys","Fun Novelties"]
  };

  const leafToGroup = new Map(); 
  const groupToLeaves = new Map(); 

  function registerGroup(groupName, leaves) {
    const groupHandle = handleize(groupName);
    const cleanLeaves = (leaves || []).filter(Boolean);

    groupToLeaves.set(groupHandle, {
      group: groupName,
      groupHandle,
      leaves: cleanLeaves
    });

    cleanLeaves.forEach((leaf) => {
      leafToGroup.set(handleize(leaf), {
        group: groupName,
        groupHandle,
        leaves: cleanLeaves
      });
    });
  }

  Object.keys(DATA).forEach((topCat) => {
    const block = DATA[topCat];

    if (isArray(block)) {
      return;
    }
    if (isObject(block)) {
      Object.keys(block).forEach((groupName) => {
        const leaves = block[groupName];
        if (isArray(leaves) && leaves.length) registerGroup(groupName, leaves);
        else registerGroup(groupName, []); 
      });
    }
  });

  const currentHandle =
    root.getAttribute("data-current-handle") ||
    (window.location.pathname.split("/collections/")[1] || "").split(/[/?#]/)[0];

  const titlePrefix = (root.getAttribute("data-title-prefix") || "Custom").trim();
  const titleEl = root.querySelector("[data-inkd-col-title]");
  const pillsEl = root.querySelector("[data-inkd-col-pills]");

  if (!currentHandle || !pillsEl) return;

  let info = leafToGroup.get(currentHandle);

  if (!info) {
    const g = groupToLeaves.get(currentHandle);
    if (g) info = { group: g.group, groupHandle: g.groupHandle, leaves: g.leaves };
  }

  if (!info || !info.group) return;

  if (titleEl) {
    titleEl.textContent = (titlePrefix ? titlePrefix + " " : "") + info.group;
  }

  pillsEl.innerHTML = "";

  function makePill(label, href, isActive) {
    const a = document.createElement("a");
    a.className = "inkd-colSubnav__pill" + (isActive ? " is-active" : "");
    a.href = href;
    a.textContent = label;
    a.setAttribute("role", "tab");
    a.setAttribute("aria-selected", isActive ? "true" : "false");
    if (isActive) a.setAttribute("aria-current", "page");
    return a;
  }

  const allActive = (currentHandle === info.groupHandle);
  pillsEl.appendChild(makePill("All", "/collections/" + info.groupHandle, allActive));

  (info.leaves || []).forEach((leaf) => {
    const leafHandle = handleize(leaf);
    const active = (currentHandle === leafHandle);
    pillsEl.appendChild(makePill(leaf, "/collections/" + leafHandle, active));
  });
})();
